/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Retry, RetryInterface } from "../Retry";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "sourceDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "blockHeight",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
    ],
    name: "Retry",
    type: "event",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "sourceDomainID",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "blockHeight",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
    ],
    name: "retry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b5061001a3361001f565b61006f565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6103398061007e6000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c80634b8f1e0214610051578063715018a6146100665780638da5cb5b1461006e578063f2fde38b1461008d575b600080fd5b61006461005f36600461025c565b6100a0565b005b610064610125565b600054604080516001600160a01b039092168252519081900360200190f35b61006461009b36600461029e565b61015b565b6000546001600160a01b031633146100d35760405162461bcd60e51b81526004016100ca906102ce565b60405180910390fd5b6040805160ff808716825285166020820152908101839052606081018290527f65d45138b1e3691f74d8f1df30225e7e36036cd84416a0a82bd26f371b2e89a99060800160405180910390a150505050565b6000546001600160a01b0316331461014f5760405162461bcd60e51b81526004016100ca906102ce565b61015960006101f6565b565b6000546001600160a01b031633146101855760405162461bcd60e51b81526004016100ca906102ce565b6001600160a01b0381166101ea5760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b60648201526084016100ca565b6101f3816101f6565b50565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b803560ff8116811461025757600080fd5b919050565b6000806000806080858703121561027257600080fd5b61027b85610246565b935061028960208601610246565b93969395505050506040820135916060013590565b6000602082840312156102b057600080fd5b81356001600160a01b03811681146102c757600080fd5b9392505050565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260408201526060019056fea2646970667358221220cda0689e9397049b799472603560478a18b45dd7d7f089ec5ac1ad4b7841dd0864736f6c634300080b0033";

type RetryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RetryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Retry__factory extends ContractFactory {
  constructor(...args: RetryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Retry";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Retry> {
    return super.deploy(overrides || {}) as Promise<Retry>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Retry {
    return super.attach(address) as Retry;
  }
  connect(signer: Signer): Retry__factory {
    return super.connect(signer) as Retry__factory;
  }
  static readonly contractName: "Retry";
  public readonly contractName: "Retry";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RetryInterface {
    return new utils.Interface(_abi) as RetryInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Retry {
    return new Contract(address, _abi, signerOrProvider) as Retry;
  }
}
